<template>
    <v-flex>
    <v-data-table
        :headers="headers"
        :items="grupos"
        :items-per-page="8"
        :loading="loading"
        class="">
        <template v-slot:item.permissoes="{ item }">
            <v-chip class="ma-1" color="blue" text-color="white" v-for="index in item.claimValue" :key="index">
                {{ index }}
            </v-chip>
        </template>
        <template v-slot:item.opcoes="{ item }">
            <v-icon >edit</v-icon>&nbsp;
            <v-icon >delete</v-icon>&nbsp;
            <v-icon >update</v-icon>&nbsp;
        </template>
        <template v-slot:item.checkbox="{item}">
            <v-checkbox
            primary
            hide-details
            class="m-0"
          ></v-checkbox>
        </template>
    </v-data-table>

        <v-overlay :value="fullLoading">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>  

        <v-dialog v-model="dialog" max-width="450">
            <v-card>
                <v-card-title class="headline">{{ this.tituloDialog }}</v-card-title>

                <v-card-text  v-if="cardText">
                {{ this.textoDialog }}
                </v-card-text>
                <v-card-text v-if="cardForm">
                    <div>
                        <v-layout wrap justify-space-between>
                            <v-flex xs12 md5>
                                <v-text-field label="Nome" tabindex="1"></v-text-field>
                            </v-flex>
                            <v-flex xs12 md5>                                
                                <v-text-field v-model="ValorBruto" label="Valor Bruto" v-formatMoney="money" return-masked-value :rules="[rules.required]" tabindex="3"></v-text-field>
                                <v-text-field v-model="Inss" label="INSS" v-formatMoney="money" return-masked-value :rules="[rules.required]" tabindex="5"></v-text-field>
                                <v-text-field v-model="ImpostoTotal" v-formatMoney="money" return-masked-value label="Imposto Total" :rules="[rules.required]" tabindex="7"></v-text-field>
                            </v-flex>                                
                        </v-layout>                        
                    </div>
                </v-card-text>                

                <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn color="red darken-1" text @click="dialog = false">
                    Cancelar
                </v-btn>                      

                </v-card-actions>
            </v-card>
            </v-dialog>          
    </v-flex>
</template>

<script>

    import Vue from 'vue';
    import moment from 'moment';
    import { mapState, mapGetters } from 'vuex';
    import Helpers from "@/utilities/Helpers";


    export default {
        mixins: [Helpers],
        data() {
            return {
                loading: false,
                fullLoading: false,
                headers: [
                    {text: "Nome", value: "claimType", sortable: false},
                    {text: "", value: "permissoes", sortable: false},
                    {text: "", value: "opcoes", sortable: false},
                    {text: "", value: "checkbox", sortable: false}
                ],
                grupos: [],
                dialog: false,
                tituloDialog: "",
                textoDialog: "",
                cardForm: false,
                cardText: false,

            }
        },
        methods: {
            carregarGrupos()
            {
                this.loading = true;
                this.fullLoading = true;
                                Vue.prototype.$httpIdentityServerApi.get(
                    `Role/${this.usuario.childRoleId}`,
                    {
                    headers: {
                        "content-type": "application/json"
                    }
                    }
                ).then(res => {
                    let _response = res.data.claims;
                    for(let item in _response) 
                    {
                        this.grupos.push({claimType : _response[item].claimType, claimValue : _response[item].claimValue });
                    }
                    this.loading = false;
                    this.fullLoading = false;
                })
                .catch(ex => {
                    console.log(ex);
                    this.loading = false;
                    this.fullLoading = false;
                });                 
            },
            limparDialog()
            {
                this.dialog = false;
                this.tituloDialog = "";
                this.textoDialog = "";
                this.cardForm = false;
                this.cardText = false;                
            },
        },
        computed: {
        ...mapGetters("usuarioModule", { usuario: "getUserInfo" })
        },
        mounted(){            
            this.carregarGrupos();
        },                        
    }
</script>
